import React, { useEffect, useState } from "react";
import {
  examtitlelist,
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
  stusubjectlist,
} from "../../../services/master";
import { AgGridReact } from "ag-grid-react";
import { Modal } from "react-bootstrap";
import { studentfilter } from "../../../services/student";
import {
  academylist,
  examstudentlist,
  studentmarkcreate,
  studentmarklist,
} from "../../../services/admin";
import Select from "react-select";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

export default function Studentwisemarkenter() {
  const [aclist, setAcList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [ayear, setAYear] = useState("");
  const [alist, setAList] = useState([]);

  const [etitle, setETitle] = useState("");
  const [tlist, setTList] = useState([]);

  const [stucls, setStuCls] = useState("");
  const [clist, setCList] = useState([]);

  const [stusec, setStuSec] = useState("");
  const [seclist, setSecList] = useState([]);

  const [stusub, setStuSub] = useState("");
  const [slist, setSList] = useState([]);

  const [ptype, setPType] = useState(1);

  const [tmark, setTMark] = useState("");
  const [pmark, setPMark] = useState("");

  const [show, setShow] = useState(false);

  const [samePracticalForAll, setSamePracticalForAll] = useState(false);
  const [sharedPracticalMark, setSharedPracticalMark] = useState("");



  useEffect(() => {


    stuclasslist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].class_name,
            });
          }
          setCList(arr);
        }
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
          setSecList(arr);
        }
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAcList(arr);
        }
      }
    });


    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0]);
                setAYear(localStorage.getItem("AYear"));
              }
            }

          }
        }
      });
    } else {
      listall("");
    }
  }, []);

  const [filterProduct, setFilterProduct] = useState([]);

  const columnDefs = [
    {
      headerName: "Action",
      field: "id",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              className="btn-sm btn-success"
              onClick={() => {
                viewshow(params.value);
              }}
            >
              <i className="fa fa-edit"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Student",
      field: "name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Theory",
      field: "theory",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Practical",
      field: "practical",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Present/Absent",
      field: "type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const [stuid, setStuID] = useState("");
  function viewshow(vid) {
    setStuID(vid);
    const vdata = filterProduct.find((item) => item.id == vid);
    if (vdata !== undefined) {
      if (vdata.type == "Present") {
        setPType(1);
      } else {
        setPType(0);
      }
      setTMark(vdata.theory);
      setPMark(vdata.practical);
    }
    setShow(true);
  }
  const [errmsg, setErrmsg] = useState("");
  function submarks(e) {
    e.preventDefault();
    setErrmsg("");
    if (ptype !== "") {
      if (tmark !== "") {
        const temp = new FormData();
        temp.append("user_id", stuid);
        temp.append("year_id", ayear);
        temp.append("class_id", stucls);
        temp.append("section_id", stusec);
        temp.append("subject_id", stusub);
        temp.append("exam_title_id", etitle);
        temp.append("present_absent", ptype);
        temp.append("theory_mark", tmark);
        temp.append("practical_mark", pmark || 0);
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
          temp.append("academy_id", acaid.value);
        }

        studentmarkcreate(temp).then((response) => {
          if (response.status === true) {
            const fdata = filterProduct.find((item) => item.id == stuid);
            if (fdata !== undefined) {
              fdata.theory = tmark;
              fdata.practical = pmark;
              if (ptype == 1) {
                fdata.type = "Present";
              } else {
                fdata.type = "Absent";
              }
            }
            setFilterProduct([...filterProduct]);
            toast.success(response.message);
            setShow(false);
            setStuID("");
          }
        });
      } else {
        setErrmsg("Please Enter Theory Marks");
      }
    } else {
      setErrmsg("Please Select Present/Absent");
    }
  }

  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setTMark(e.target.value);
    }
  };

  const handlePractical = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPMark(e.target.value);
    }
  };

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e);
    } else {
      setAcaID("");
      listall("");
    }
  }

  function listall(aid) {
    setAList([]);
    setAYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].aca_year,
            });
          }
          setAList(arr);
        }
      }
    });

    examtitlelist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].exam_title,
            });
          }
          setTList(arr);
        }
      }
    });

    stusubjectlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].subject_name,
            });
          }
          setSList(arr);
        }
      }
    });

  }

  function filterstu() {
    setSErrMsg("");
    setFilterProduct([]);
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setSErrMsg("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }

    if (valid === "") {
      if (ayear !== "") {
        if (stucls !== "") {
          if (stusec !== "") {
            if (etitle !== "") {
              if (stusub !== "") {
                examstudentlist(1, 0).then((res) => {
                  if (res.status === true) {
                    const sdata = res.data.find(
                      (item) =>
                        item.exam_type == etitle &&
                        item.subject_id == stusub &&
                        item.class_id == stucls &&
                        item.section == stusec
                    );

                    if (sdata !== undefined) {
                      const temp = new FormData();
                      temp.append("year", ayear);
                      temp.append("class", stucls);
                      temp.append("section", stusec);
                      if (
                        localStorage.getItem("Role") === "1" &&
                        acaid !== ""
                      ) {
                        temp.append("academy", acaid.value);
                      }
                      studentfilter(temp).then((res) => {
                        if (res.status === true) {
                          let arr = [];

                          if (res.data.details.length > 0) {
                            for (let i = 0; i < res.data.details.length; i++) {
                              arr.push({
                                id: res.data.details[i].user_id,
                                username: res.data.details[i].username,
                                name: res.data.details[i].student_name,
                                type: "Present",
                                theory: "",
                                practical: "",
                              });
                            }
                          } else {
                            Swal.fire({
                              title:
                                "There is no student in this class and section in the selected year.",
                              icon: "warning",
                              showCancelButton: false,
                            });
                          }
                          setFilterProduct(arr);
                          if (arr.length !== 0) {
                            const temp1 = new FormData();
                            temp1.append("year_id", ayear);
                            temp1.append("class_id", stucls);
                            temp1.append("section_id", stusec);
                            temp1.append("subject_id", stusub);
                            temp1.append("exam_title_id", etitle);
                            if (
                              localStorage.getItem("Role") === "1" &&
                              acaid !== ""
                            ) {
                              temp1.append("academy_id", acaid.value);
                            }

                            studentmarklist(temp1).then((res1) => {
                              if (res1.status === true && res1.data) {
                                const updatedArr = arr.map((item) => {
                                  const userData = res1.data.find(
                                    (user) => user.user_id == item.id
                                  );

                                  if (userData) {
                                    let vdata = "Present";
                                    if (userData.present_absent == 0) {
                                      vdata = "Absent";
                                    }
                                    return {
                                      ...item,
                                      type: vdata,
                                      theory: userData.theory_mark,
                                      practical: userData.practical_mark,
                                    };
                                  }

                                  return item;
                                });
                                setFilterProduct([...updatedArr]);
                              }
                            });
                          }
                        }
                      });
                    } else {
                      Swal.fire({
                        title:
                          "There is no exam created for this class,section,exam title and subject.",
                        icon: "warning",
                        showCancelButton: false,
                      });
                    }
                  }
                });
              } else {
                setSErrMsg("Please Select Subject");
              }
            } else {
              setSErrMsg("Please Select Exam Title");
            }
          } else {
            setSErrMsg("Please Select Section");
          }
        } else {
          setSErrMsg("Please Select Class");
        }
      } else {
        setSErrMsg("Please Select Academic Year");
      }
    }
  }

  const [serrmsg, setSErrMsg] = useState("");
  const handleTheoryChange = (id, value) => {
    setFilterProduct(prev =>
      prev.map(item =>
        item.id === id ? { ...item, theory: value } : item
      )
    );
  };

  // const handlePracticalChange = (id, value) => {
  //   setFilterProduct(prev =>
  //     prev.map(item =>
  //       item.id === id ? { ...item, practical: value } : item
  //     )
  //   );
  // };
  const handlePracticalChange = (id, value) => {
    if (samePracticalForAll) {
      setSharedPracticalMark(value);

      const updated = filterProduct.map((item) => ({
        ...item,
        practical: value,
      }));
      setFilterProduct(updated);
    } else {
      const updated = filterProduct.map((item) =>
        item.id === id ? { ...item, practical: value } : item
      );
      setFilterProduct(updated);
    }
  };

  const handleAttendanceChange = (id, value) => {
    setFilterProduct(prev =>
      prev.map(item =>
        item.id === id ? { ...item, type: value } : item
      )
    );
  };
  const [loading, setLoading] = useState(false);
  const submitAllMarks = () => {
    const isValid = filterProduct.every(item =>
      item.theory !== "" && item.practical !== "" && item.type
    );

    if (!isValid) {
      toast.error("Please fill all fields for each student.");
      return;
    }

    setLoading(true); // Start loading

    const promises = filterProduct.map((item) => {
      const temp = new FormData();
      temp.append("user_id", item.id);
      temp.append("year_id", ayear);
      temp.append("class_id", stucls);
      temp.append("section_id", stusec);
      temp.append("subject_id", stusub);
      temp.append("exam_title_id", etitle);
      temp.append("present_absent", item.type === "Present" ? 1 : 0);
      temp.append("theory_mark", item.theory);
      temp.append("practical_mark", item.practical || 0);

      if (localStorage.getItem("Role") === "1" && acaid !== "") {
        temp.append("academy_id", acaid.value);
      }

      return studentmarkcreate(temp); // Return the promise
    });

    Promise.all(promises)
      .then((responses) => {
        const hasError = responses.some((res) => res.status !== true);

        if (hasError) {
          toast.error("Some records failed to save.");
        } else {
          toast.success("All student marks saved successfully.");
        }
        filterstu();
      })
      .catch((error) => {
        console.error("Error saving student marks:", error);
        toast.error("An unexpected error occurred while saving marks.");
      })
      .finally(() => {
        setLoading(false);
      });




    // API call here
    // submitMarks(formData).then(res => {
    //   if (res.status === true) {
    //     toast.success("Marks submitted successfully");
    //     // Optional: redirect or reset state
    //   } else {
    //     toast.error("Submission failed: " + res.message);
    //   }
    // });
  };

  const [allPresentChecked, setAllPresentChecked] = useState(false);
  const [allAbsentChecked, setAllAbsentChecked] = useState(false);

  const updateAllAttendance = (status) => {
    const updated = filterProduct.map((item) => ({
      ...item,
      type: status,
    }));
    setFilterProduct(updated);
  };

  const handleAllPresentChange = (e) => {
    const checked = e.target.checked;
    setAllPresentChecked(checked);
    setAllAbsentChecked(false);

    if (checked) {
      updateAllAttendance("Present");
    }
  };

  const handleAllAbsentChange = (e) => {
    const checked = e.target.checked;
    setAllAbsentChecked(checked);
    setAllPresentChecked(false);

    if (checked) {
      updateAllAttendance("Absent");
    }
  };


  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">
          Student Wise Markenter
        </h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Exam</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Student Wise Markenter
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading &&
        <div className="content-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Student Wise Markenter
                    </h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {localStorage.getItem("Role") === "1" && (
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Select Academy{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <Select
                              className="default-select"
                              placeholder="Select Academy"
                              value={acaid}
                              options={aclist}
                              onChange={handleAcademy}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                          </div>
                        </div>
                      )}

                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-6">
                          <label className="form-label">
                            Academic Year<span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select form-control wide"
                            onChange={(e) => {setAYear(e.target.value);setFilterProduct([]);}}
                            value={ayear}
                          >
                            <option value="" disabled>
                              Select Academic Year
                            </option>
                            {alist.map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-6">
                          <label className="form-label">
                            Select Class<span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select form-control wide"
                            onChange={(e) => {setStuCls(e.target.value);setFilterProduct([]);}}
                            value={stucls}
                          >
                            <option value="" disabled>
                              Select Class
                            </option>
                            {clist.map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-6">
                          <label className="form-label">
                            Section<span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select form-control wide"
                            onChange={(e) => {setStuSec(e.target.value);setFilterProduct([]);}}
                            value={stusec}
                          >
                            <option value="" disabled>
                              Select Section
                            </option>
                            {seclist.map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-6">
                          <label className="form-label">
                            Exam Title<span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select form-control wide"
                            onChange={(e) => {setETitle(e.target.value);setFilterProduct([]);}}
                            value={etitle}
                          >
                            <option value="" disabled>
                              Select Exam Title
                            </option>
                            {tlist.map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-6">
                          <label className="form-label">
                            Select Exam Subjects
                            <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select form-control wide"
                            onChange={(e) => {setStuSub(e.target.value);setFilterProduct([]);}}
                            value={stusub}
                          >
                            <option value="" disabled>
                              Select Exam Subjects
                            </option>
                            {slist.map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                     {serrmsg !== "" && (
                        <span className="text-danger">{serrmsg}</span>
                      )}
                    <div className="float-end mt-3">
                      <a className="btn btn-success me-2" onClick={filterstu}>
                        {" "}
                        Search
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 mt-2">
                <div className="card custom-card mg-b-20">
                  <div className="card-body">
                    {/* <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Enter Subject Mark

                    </h2>
                  </div> */}
                    {/* <div className="ag-theme-alpine ag-style">
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={filterProduct}
                      pagination="true"
                      paginationPageSize="10"
                      sortingOrder={["asc", "desc"]}
                      suppressDragLeaveHidesColumns={true}
                    />
                  </div> */}


                    {/* Same Practical Marks */}
                    <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap p-3 rounded"  style={{ backgroundColor: "#f8f9fa" }}>
                      {/* Left Side: Same Practical Checkbox */}
                      <div className="form-check">
                        <input
                          className="styled-checkbox" 
                          type="checkbox"
                          id="samePractical"
                          checked={samePracticalForAll}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setSamePracticalForAll(checked);
                            if (!checked) setSharedPracticalMark("");
                          }}
                        />
                        {/* <label className="form-check-label ms-2 mt-3" htmlFor="samePractical"> */}
                         {" " }Apply same practical marks to all
                        {/* </label> */}
                      </div>

                      {/* Right Side: All Present / All Absent */}
                      <div className="d-flex gap-4">
                        <div className="form-check">
                          <input
                            className="styled-checkbox" 
                            type="checkbox"
                            id="allPresent"
                            checked={allPresentChecked}
                            onChange={handleAllPresentChange}
                          />
                          {/* <label className="form-check-label ms-2 mt-3" htmlFor="allPresent"> */}
                            {" " }All Present
                          {/* </label> */}
                        </div>

                        <div className="form-check">
                          <input
                            className="styled-checkbox" 
                            type="checkbox"
                            id="allAbsent"
                            checked={allAbsentChecked}
                            onChange={handleAllAbsentChange}
                          />
                          {/* <label className="form-check-label ms-2 mt-3" htmlFor="allAbsent"> */}
                            {" " }All Absent
                          {/* </label> */}
                        </div>
                      </div>
                    </div>



                    <div className="table-responsive tasks">
                      <table className="table card-table table-vcenter text-nowrap mb-0 border">
                        <thead>
                          <tr>
                            {/* <th className="text-center">Action</th> */}
                            <th className="text-center">Student</th>
                            <th className="text-center">Theory</th>
                            <th className="text-center">Practical</th>
                            <th className="text-center">Present/Absent</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filterProduct.map((item, index) => (
                            <tr key={index}>
                              {/* Action */}
                              {/* <td className="text-center">
                              <a
                                className="btn-sm btn-success"
                                onClick={() => {
                                  viewshow(item.id);
                                }}
                              >
                                <i className="fa fa-edit"></i>
                              </a>
                            </td> */}

                              {/* Student Name */}
                              <td className="text-center">{item.name}</td>

                              {/* Editable Theory Marks */}
                              <td className="text-center">
                                <input
                                  type="number"
                                  className="form-control text-center"
                                  value={item.theory}
                                  onChange={(e) =>
                                    handleTheoryChange(item.id, e.target.value)
                                  }
                                  placeholder="Enter theory marks"
                                />
                              </td>

                              {/* Editable Practical Marks */}
                              <td className="text-center">
                                <input
                                  type="number"
                                  className="form-control text-center"
                                  value={item.practical}
                                  onChange={(e) =>
                                    handlePracticalChange(item.id, e.target.value)
                                  }
                                  placeholder="Enter practical marks"
                                />
                              </td>

                              {/* Editable Present/Absent Dropdown */}
                              <td className="text-center">
                                <select
                                  className="form-control"
                                  value={item.type ?? "Present"}
                                  onChange={(e) => handleAttendanceChange(item.id, e.target.value)}
                                >
                                  <option value="">Select</option>
                                  <option value="Present">Present</option>
                                  <option value="Absent">Absent</option>
                                </select>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {filterProduct.length > 0 && (
                      <div className="res-right mt-2">
                        <button
                          className="btn btn-success"
                          onClick={submitAllMarks}
                        >
                          Submit
                        </button>
                      </div>

                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }


      <Modal show={show} size="lg">
        <Modal.Header>
          <Modal.Title>Exam Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-xl-6 col-sm-6">
              <div className="mb-6">
                <label className="form-label">
                  Present/Absent
                  <span className="text-danger"> *</span>
                </label>
                <select
                  className="default-select form-control wide"
                  onChange={(e) => setPType(e.target.value)}
                  value={ptype}
                >
                  <option value="" disabled>
                    Select Present/Absent
                  </option>
                  <option value={1}>Present</option>
                  <option value={0}>Absent</option>
                </select>
              </div>
            </div>

            <div className="col-xl-6 col-sm-6">
              <div className="mb-6">
                <label className="form-label">
                  Theory Marks
                  <span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Theory Marks"
                  className="form-control"
                  onChange={handleChange}
                  value={tmark}
                  maxLength={5}
                />
              </div>
            </div>
            <div className="col-xl-6 col-sm-6">
              <div className="mb-6">
                <label className="form-label">
                  Practical Marks
                  {/* <span className="text-danger"> *</span> */}
                </label>
                <input
                  type="text"
                  placeholder="Enter Practical Marks"
                  className="form-control"
                  onChange={handlePractical}
                  value={pmark}
                  maxLength={5}
                />
              </div>
            </div>
          </div>
          {errmsg !== "" && <span className="text-danger">{errmsg}</span>}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-success" onClick={submarks}>
            Submit
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setShow(false);
              setStuID("");
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
